import { render, staticRenderFns } from "./selectPopup.vue?vue&type=template&id=8973cdf8&scoped=true&"
import script from "./selectPopup.vue?vue&type=script&lang=js&"
export * from "./selectPopup.vue?vue&type=script&lang=js&"
import style0 from "./selectPopup.vue?vue&type=style&index=0&id=8973cdf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8973cdf8",
  null
  
)

export default component.exports